import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20breathtaking%20aerial%20view%20of%20a%20tropical%20Asian%20beach%20with%20crystal%20clear%20turquoise%20water%20and%20white%20sand%2C%20traditional%20wooden%20longtail%20boats%20floating%20on%20calm%20sea%2C%20lush%20green%20palm%20trees%20along%20the%20shore%2C%20dramatic%20warm%20sunset%20sky%20with%20golden%20orange%20and%20soft%20pink%20hues%2C%20dreamy%20and%20luxurious%20travel%20atmosphere%2C%20high%20end%20travel%20magazine%20photography%20style%2C%20clean%20balanced%20composition%20with%20ample%20negative%20space%20in%20the%20upper%20sky%20area&width=1600&height=900&seq=hero-banner-main&orientation=landscape"
        alt="亚洲天堂 - 探索东方最美旅游胜地"
        title="亚洲天堂 - 探索东方最美旅游胜地"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
        <span className="inline-block px-4 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm text-white/90 text-xs md:text-sm mb-5 md:mb-6 tracking-wider">
          探索东方最美的旅游胜地
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl">
          亚洲天堂
        </h1>
        <p className="text-white/80 text-sm md:text-lg mt-4 md:mt-5 max-w-2xl leading-relaxed">
          从碧海白沙到千年古迹，从热带雨林到都市繁华<br className="hidden md:block" />
          汇聚东南亚、东亚及南亚最令人心动的绝美目的地
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-7 md:mt-9">
          <Link
            to="/category/southeast-asia"
            className="inline-flex items-center px-7 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            探索目的地
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center px-7 py-3 rounded-full border border-white/50 text-white font-medium text-sm hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-1.5 text-white/60 text-xs">
          <span>向下滚动探索</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}